import {User} from '@pages/pilotage-rh/users/user-types';
import {z as zod} from '@providers/zod';

export type Account = {
  uuid: string;
  ciamId: string;
  label: string;
  subscriptions: AccountSubscription[];
  createdAt: string;
  updatedAt: string;
  owner: User;
  email: string;
  firstName: string;
  lastName: string;
  bdeseId: number | null;
  accountOrigin: string;
  connectorDSN: AccountConnectorDsn | null;
};

export type ConfigConnectorSilae = {
  clientId: string;
  clientSecret: string;
  idConfig: string;
  mainKey: string;
};
export type AccountConnectorDsn = {
  type: string;
  config: ConfigConnectorSilae;
  periodStart: string;
  periodEnd: string;
};

export type AccountSubscription = {
  service: string;
  code: string;
  subscribedAt: string;
  monthOfSubscription: number;
  expiresAt: string | null;
  fromApi: boolean;
};

export const AccountSchema = zod
  .object({
    email: zod.string().email(),
    label: zod.string().nonempty(),
    subscriptions: zod.array(
      zod.object({
        service: zod.string().nonempty(),
        code: zod.string().nonempty(),
        monthOfSubscription: zod.number(),
        subscribedAt: zod.string().nonempty(),
      }),
    ),
    firstName: zod.string().nonempty(),
    lastName: zod.string().nonempty(),
    bdeseId: zod.number().nullable(),
    users: zod.array(
      zod.object({
        uuid: zod.string().nonempty(),
        email: zod.string().email(),
        firstName: zod.string().nonempty(),
        lastName: zod.string().nonempty(),
      }),
    ),
    connectorDSN: zod
      .object({
        type: zod.literal('silae'),
        config: zod.object({
          clientId: zod.string().nonempty(),
          clientSecret: zod.string().nonempty(),
          idConfig: zod.string().nonempty(),
          mainKey: zod.string().nonempty(),
        }),
        periodStart: zod.string().nonempty(),
        periodEnd: zod.string().nullable(),
      })
      .nullable(),
  })
  .refine(
    (data) => {
      return data.subscriptions.length > 0;
    },
    {
      message: 'One subscription at least is required',
      path: ['subscriptions'],
    },
  );

export const CONNECTOR_TYPES = ['silae'] as const;
export type ConnectorType = (typeof CONNECTOR_TYPES)[number];

export enum SubscriptionEnum {
  SUBSCRIPTION_NONE = 'SUBSCRIPTION_NONE',
  SUBSCRIPTION_TRIAL = 'SUBSCRIPTION_TRIAL',
  SUBSCRIPTION_PAID = 'SUBSCRIPTION_PAID',
}
export const SubscriptionValues = Object.values(SubscriptionEnum);
export const SubscriptionTranslations = {
  [SubscriptionEnum.SUBSCRIPTION_TRIAL]: {
    label: 'pages.pilotage-rh.account.values.subscription.trial.label',
    description: 'pages.pilotage-rh.account.values.subscription.trial.description',
  },
  [SubscriptionEnum.SUBSCRIPTION_PAID]: {
    label: 'pages.pilotage-rh.account.values.subscription.paid.label',
    description: 'pages.pilotage-rh.account.values.subscription.paid.description',
  },
};
